var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-message"},[(_vm.error)?_c('img',{attrs:{"src":_vm.errorIconPass}}):_vm._e(),(_vm.error)?_c('span',[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }